export default "__VITE_ASSET__BZTMKqDZ__"